import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/mezoterapi-etkileri-ne-zaman-gorulur/page.tsx");
